export default "__VITE_ASSET__8544ee80__"